import { FLAGS } from '~/constants/flags'
import { CONTROL_PANEL_ROUTES } from '~/constants/router'
import { adminRoles } from '~/modules/auth/conditions'
import { lazyRetry } from '~/utils/lazyRetry'

const ControlPanelPage = lazyRetry(() =>
  import('@bs/control-panel').then((m) => ({ default: m.ControlPanelPage })),
)

const ControlPanelRouters = [
  {
    path: `${CONTROL_PANEL_ROUTES.CONTROL_PANEL}/*`,
    component: ControlPanelPage,
    exact: false,
    routeName: 'Control Panel',
    roles: adminRoles,
    featureFlag: FLAGS.CONTROL_PANEL,
  },
]

export default ControlPanelRouters
